import { Stack, Typography } from "@mui/material";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";

type Props = {
	icon: string;
	label: string;
};

export default function OptLanguage({ icon, label }: Props) {
	const { translate } = useLocales();
	return (
		<Stack alignItems='center' flexDirection='row' gap={1}>
			<Image src={icon} sx={{ width: 20, height: 14 }} />
			<Typography variant='subtitle1'>{translate(`languages.${label}`)}</Typography>
		</Stack>
	);
}
